<template>
  <v-dialog :value="dialog" fullscreen>
    <v-card>
      <v-card-title class="headline"></v-card-title>

      <v-card-text class="text-center">
        Está com dúvidas sobre o CEM, tem reclamações ou quer só bater um papo mesmo?
        <br />
          Fale com a gente :)
          <br /><br />
        <a href="https://web.whatsapp.com/send?phone=+554833222574" target="_blank">
          <v-btn color="primary" outlined rounded >
            <v-icon class="mr-1">mdi-whatsapp</v-icon> Contatar pelo WhatsApp
          </v-btn>
        </a>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="dialog = false">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from "@/mixins/dialogs/DialogMixin";

export default {
  mixins: [DialogMixin],
  components: {},
  data() {
    return {
      defaultForm: {}
    };
  }
};
</script>
